import { components } from "react-select";


export const MultiValueLabelWithCheck = (props) => (
  <components.MultiValueLabel {...props}>
    <span style={{ marginRight: 6, color: "#166534", fontWeight: 800 }}>✓</span>
    {props.children}
  </components.MultiValueLabel>
);


export const SingleValueWithCheck = (props) => (
  <components.SingleValue {...props}>
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: "#e8f7ee",
        border: "1px solid #b8e6c8",
        borderRadius: 8,
        padding: "4px 8px",
        width: "max-content",
        maxWidth: "100%",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ fontWeight: 800 }}>✓</span>
      {props.children}
    </span>
  </components.SingleValue>
);


export const OptionWithCheckAndRemove = (props) => {
  const { isSelected, label, data, getValue, setValue, selectProps } = props;
  const isMulti = !!selectProps?.isMulti;

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isMulti) {
  
      setValue(null, "clear");
      return;
    }

    const current = getValue() || [];
    const next = current.filter((v) => v.value !== data.value);

  
    setValue(next, "remove-value", data);
  };

  return (
    <components.Option {...props}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        {/* LEFT: check + label */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              width: 16,
              display: "inline-block",
              color: "#166534",
              fontWeight: 800,
              opacity: isSelected ? 1 : 0,
            }}
          >
            ✓
          </span>

          <span style={{ fontWeight: isSelected ? 600 : 400 }}>{label}</span>
        </div>

        {/* RIGHT: x (only if selected) */}
        {isSelected ? (
          <span
            onMouseDown={(e) => e.preventDefault()} // prevents focus/menu weirdness
            onClick={handleRemove}
            style={{
              color: "#166534",
              fontWeight: 800,
              cursor: "pointer",
              padding: "0 6px",
              lineHeight: 1,
            }}
            title="Remove"
          >
            ×
          </span>
        ) : null}
      </div>
    </components.Option>
  );
};



export const makeSelectStylesGreenChecks = (baseStyles) => ({
  ...baseStyles,

 
  control: (base, state) => ({
    ...base,
    ...(typeof baseStyles?.control === "function" ? baseStyles.control(base, state) : {}),
    boxShadow: "none",
    borderColor: state.isFocused ? "#22c55e" : base.borderColor,
    "&:hover": {
      borderColor: state.isFocused ? "#22c55e" : base.borderColor,
    },
  }),

  
  singleValue: (base) => ({
    ...base,
    color: "#166534",
    fontWeight: 600,
    maxWidth: "100%",
    fontSize: 13,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4,
    display: "inline-flex",
    alignItems: "center",
  }),

  valueContainer: (base) => ({
    ...base,
    paddingLeft: 12,
  }),

  placeholder: (base) => ({
    ...base,
    color: "#A9ACBE",
  }),

  option: (base, state) => {
    const bg = state.isSelected ? "#dcfce7" : state.isFocused ? "#f0fdf4" : "#fff";

    return {
      ...base,
      backgroundColor: bg,
      color: state.isSelected ? "#166534" : "#111827",
      fontWeight: state.isSelected ? 600 : 400,
      cursor: "pointer",


      ":active": {
        backgroundColor: "#dcfce7",
      },
    };
  },

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e8f7ee",
    border: "1px solid #b8e6c8",
    borderRadius: 8,
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#166534",
    fontWeight: 600,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#166534",
    ":hover": {
      backgroundColor: "#c9f1d8",
      color: "#14532d",
    },
  }),
});



export const greenCheckComponents = {
  IndicatorSeparator: () => null,
  Option: OptionWithCheckAndRemove,
  MultiValueLabel: MultiValueLabelWithCheck,
  SingleValue: SingleValueWithCheck,

};






